import React, { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import "../customScrollbar.css"

const DashboardLayout = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const currentPath = location.pathname;
useEffect(() => {
  const session = Cookies.get("session");
  if (!session || session !== "loggedIn") {
    window.location.href = "/dashboard";
  }
},[])
  const navBgColor = 'bg-gray-100';

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const links = [
    { title: 'Dashboard', icon: 'fa-solid fa-gauge-high', link: '/dashboard/main/' },
    { title: 'Products', icon: 'fa-solid fa-box', link: '/dashboard/main/product' },
    { title: 'News & Events', icon: 'fa-solid fa-inbox', link: '/dashboard/main/news' },
  ];

  return (
    <div className={`flex ${navBgColor}`}>
      <nav className={`fixed top-0 z-50 w-full ${navBgColor}`}>
        <div className="px-3 py-3 lg:px-5 lg:pl-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center justify-start">
              <button
                aria-controls="logo-sidebar"
                type="button"
                className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
                onClick={toggleSidebar}
              >
                <span className="sr-only">Open sidebar</span>
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path>
                </svg>
              </button>
              <a href="#" className="flex ms-2 md:me-24 md:px-20">
                <img
                  src={require("../assets/logo.png")}
                  className="h-8"
                  alt="FlowBite Logo"
                />
              </a>
            </div>
            <div className="relative flex items-center">
              <button
                type="button"
                className="flex text-sm bg-gray-800 rounded-full focus:ring-4 focus:ring-gray-300"
                aria-expanded={isDropdownOpen}
                onClick={toggleDropdown}
              >
                <span className="sr-only">Open user menu</span>
                <img
                  className="w-8 h-8 rounded-full"
                  src="https://flowbite.com/docs/images/people/profile-picture-5.jpg"
                  alt="user photo"
                />
              </button>
              {isDropdownOpen && (
                <div
                  className="absolute right-0 top-10 mt-2 w-48 bg-white divide-y divide-gray-100 rounded shadow"
                  id="dropdown-user"
                >
                  <div className="px-4 py-3">
                    <p className="text-sm text-gray-900">Admin</p>
          
                  </div>
                  <ul className="py-1">
                   
                    <li>
                      <a
                        href="#"
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        onClick={() => {
                          Cookies.remove("session");
                          window.location.href = "/dashboard";
                        }}  
                      >
                        Sign out
                      </a>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>

      <aside
        id="logo-sidebar"
        className={`fixed top-0 left-0 z-40 w-64 h-screen pt-20 transition-transform transform ${
          isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } ${navBgColor} sm:translate-x-0`}
        aria-label="Sidebar"
      >
        <div className={`h-full px-3 pb-4 overflow-y-auto ${navBgColor}`}>
          <ul className="space-y-2 font-medium">
            {links.map((link) => (
              <li key={link.title}>
                <NavLink
                  to={link.link}
                  className={`flex items-center p-2 text-gray-900 rounded-lg hover:bg-blue-500 hover:text-white group ${
                    currentPath === link.link ? 'bg-[#005CB9] text-white' : ''
                  }`}
                >
                  <i className={link.icon}></i>
                  <span className="ms-3">{link.title}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </aside>

      <main className={`flex-1 p-4 sm:ml-64 ${navBgColor} h-screen`}>
      <div className="p-4 md:mt-10 mt-20 bg-white border border-gray-200 rounded-lg shadow-md h-[95%] overflow-y-scroll custom-scrollbar">
      <Outlet />
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
